import {
  GET_EMPLOYEESLIST,
  GET_EMPLOYEEDETAILS,
  GET_ADDEMPLOYEE,
  GET_UPDATEEMPLOYEE,
  UPLOAD_EMPLOYEE_EXCEL,
  APPROVE_EMPLOYEE,
  REJECT_EMPLOYEE,
} from "resources/actionTypes";

const initialEmployeesListState = {
  loading: false,
  error: null,
  employeesList: "",
};

const initialEmployeeDetailsState = {
  loading: false,
  error: null,
  employeeDetails: "",
};

const initialAddEmployeeState = {
  loading: false,
  error: null,
};

const initialUpdateEmployeeState = {
  loading: false,
  error: null,
};

const initialUploadEmployeeExcelState = {
  loading: false,
  error: null,
  data: null,
};

const initialApproveEmployeeState = {
  loading: false,
  error: null,
};
const initialRejectEmployeeState = {
  loading: false,
  error: null,
};
// Employee List
export const getEmployeesList = (state = initialEmployeesListState, action) => {
  switch (action.type) {
    case GET_EMPLOYEESLIST.GET_EMPLOYEESLIST_REQUESTED:
      return {
        ...state,
        loading: true,
      };

    case GET_EMPLOYEESLIST.GET_EMPLOYEESLIST_SUCCESS:
      return {
        ...state,
        loading: false,
        employeesList: action.employeesList,
      };

    case GET_EMPLOYEESLIST.GET_EMPLOYEESLIST_CLEARED:
      return {
        ...state,
        loading: false,
        employeesList: [],
      };

    case GET_EMPLOYEESLIST.GET_EMPLOYEESLIST_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };

    default:
      return state;
  }
};

// Employee Details
export const getEmployeeDetails = (
  state = initialEmployeeDetailsState,
  action,
) => {
  switch (action.type) {
    case GET_EMPLOYEEDETAILS.GET_EMPLOYEEDETAILS_REQUESTED:
      return {
        ...state,
        loading: true,
      };

    case GET_EMPLOYEEDETAILS.GET_EMPLOYEEDETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        employeeDetails: action.employeesDetails,
      };

    case GET_EMPLOYEEDETAILS.GET_EMPLOYEEDETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };

    case GET_EMPLOYEEDETAILS.GET_EMPLOYEEDETAILS_RESET:
      return {
        ...state,
        employeeDetails: "",
      };

    default:
      return state;
  }
};

// Add Employee
export const addEmployee = (state = initialAddEmployeeState, action) => {
  switch (action.type) {
    case GET_ADDEMPLOYEE.GET_ADDEMPLOYEE_REQUESTED:
      return {
        ...state,
        loading: true,
      };

    case GET_ADDEMPLOYEE.GET_ADDEMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case GET_ADDEMPLOYEE.GET_ADDEMPLOYEE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };

    default:
      return state;
  }
};

// Update Employee
export const updateEmployee = (state = initialUpdateEmployeeState, action) => {
  switch (action.type) {
    case GET_UPDATEEMPLOYEE.GET_UPDATEEMPLOYEE_REQUESTED:
      return {
        ...state,
        loading: true,
      };

    case GET_UPDATEEMPLOYEE.GET_UPDATEEMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case GET_UPDATEEMPLOYEE.GET_UPDATEEMPLOYEE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };

    default:
      return state;
  }
};

// Upload Excel
export const uploadEmployeeExcel = (
  state = initialUploadEmployeeExcelState,
  action,
) => {
  switch (action.type) {
    case UPLOAD_EMPLOYEE_EXCEL.UPLOAD_EMPLOYEE_EXCEL_REQUESTED:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case UPLOAD_EMPLOYEE_EXCEL.UPLOAD_EMPLOYEE_EXCEL_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.data,
      };

    case UPLOAD_EMPLOYEE_EXCEL.UPLOAD_EMPLOYEE_EXCEL_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };

    case UPLOAD_EMPLOYEE_EXCEL.UPLOAD_EMPLOYEE_EXCEL_RESET:
      return {
        ...state,
        data: null,
        error: null,
        loading: false,
      };

    default:
      return state;
  }
};

// Approve Employee
export const approveEmployee = (
  state = initialApproveEmployeeState,
  action,
) => {
  switch (action.type) {
    case APPROVE_EMPLOYEE.APPROVE_EMPLOYEE_REQUESTED:
      return {
        ...state,
        loading: true,
      };

    case APPROVE_EMPLOYEE.APPROVE_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case APPROVE_EMPLOYEE.APPROVE_EMPLOYEE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };

    default:
      return state;
  }
};
export const rejectEmployee = (state = initialRejectEmployeeState, action) => {
  switch (action.type) {
    case REJECT_EMPLOYEE.REJECT_EMPLOYEE_REQUESTED:
      return {
        ...state,
        loading: true,
      };

    case REJECT_EMPLOYEE.REJECT_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case REJECT_EMPLOYEE.REJECT_EMPLOYEE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };

    default:
      return state;
  }
};
